import { useState } from 'react'
import { Select } from '../../components/Select'
import type { SelectOption, UserOption } from '../../components/Select'
import { ComponentsLayout } from './layout'

export const SelectsPage = () => {
  const [simpleValue, setSimpleValue] = useState<string | number>('')
  const [categoryValue, setCategoryValue] = useState<string | number>('')
  const [userValue, setUserValue] = useState<string | number>('')
  const [assigneeValue, setAssigneeValue] = useState<string | number>('')

  // Opções simples
  const simpleOptions: SelectOption[] = [
    { value: 'option1', label: 'Opção 1' },
    { value: 'option2', label: 'Opção 2' },
    { value: 'option3', label: 'Opção 3' },
    { value: 'option4', label: 'Opção 4', disabled: true },
  ]

  // Opções de categoria
  const categoryOptions: SelectOption[] = [
    { value: 'bug', label: '🐛 Bug' },
    { value: 'feature', label: '✨ Feature' },
    { value: 'improvement', label: '⚡ Melhoria' },
    { value: 'documentation', label: '📚 Documentação' },
    { value: 'test', label: '🧪 Teste' },
  ]

  // Opções de usuários
  const userOptions: UserOption[] = [
    {
      value: 'user1',
      label: 'João Silva',
      name: 'João Silva',
      email: 'joao.silva@empresa.com',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=40&h=40&fit=crop&crop=face'
    },
    {
      value: 'user2',
      label: 'Maria Santos',
      name: 'Maria Santos',
      email: 'maria.santos@empresa.com',
      avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=40&h=40&fit=crop&crop=face'
    },
    {
      value: 'user3',
      label: 'Pedro Costa',
      name: 'Pedro Costa',
      email: 'pedro.costa@empresa.com'
    },
    {
      value: 'user4',
      label: 'Ana Oliveira',
      name: 'Ana Oliveira',
      email: 'ana.oliveira@empresa.com',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=40&h=40&fit=crop&crop=face'
    },
    {
      value: 'user5',
      label: 'Carlos Ferreira',
      name: 'Carlos Ferreira',
      email: 'carlos.ferreira@empresa.com'
    },
  ]

  return (
    <ComponentsLayout 
      title="Selects" 
      description="Componentes de seleção personalizados e modernos"
    >
      {/* Grid de exemplos */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        
        {/* Select Simples */}
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Select Simples</h3>
          <div className="space-y-4">
            <Select
              options={simpleOptions}
              value={simpleValue}
              onChange={setSimpleValue}
              placeholder="Escolha uma opção..."
            />
            <Select
              options={simpleOptions}
              placeholder="Select desabilitado"
              disabled
            />
          </div>
          <div className="mt-4 text-sm text-gray-600">
            <strong>Uso:</strong> Seleção simples com estilo personalizado
          </div>
        </div>

        {/* Select com Categorias */}
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Select com Ícones</h3>
          <div className="space-y-4">
            <Select
              options={categoryOptions}
              value={categoryValue}
              onChange={setCategoryValue}
              placeholder="Selecione uma categoria..."
            />
          </div>
          <div className="mt-4 text-sm text-gray-600">
            <strong>Uso:</strong> Opções com emojis e ícones
          </div>
        </div>

        {/* Select de Usuários */}
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Select de Usuários</h3>
          <div className="space-y-4">
            <Select
              variant="user"
              options={userOptions}
              value={userValue}
              onChange={setUserValue}
              placeholder="Selecione um usuário..."
              searchable
            />
          </div>
          <div className="mt-4 text-sm text-gray-600">
            <strong>Uso:</strong> Seleção de usuários com avatar e busca
          </div>
        </div>

        {/* Select de Usuários sem Busca */}
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Usuários sem Busca</h3>
          <div className="space-y-4">
            <Select
              variant="user"
              options={userOptions.slice(0, 3)}
              value={assigneeValue}
              onChange={setAssigneeValue}
              placeholder="Atribuir para..."
              searchable={false}
            />
          </div>
          <div className="mt-4 text-sm text-gray-600">
            <strong>Uso:</strong> Lista de usuários sem campo de busca
          </div>
        </div>

        {/* Comparação com Select Nativo */}
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Select Nativo</h3>
          <div className="space-y-4">
            <select 
              className="w-full h-10 px-3 py-2 border border-gray-300 rounded-md bg-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500"
              aria-label="Select nativo"
            >
              <option value="">Selecione...</option>
              <option value="1">Opção 1</option>
              <option value="2">Opção 2</option>
              <option value="3">Opção 3</option>
            </select>
          </div>
          <div className="mt-4 text-sm text-gray-600">
            <strong>Comparação:</strong> Select HTML nativo
          </div>
        </div>

        {/* Estados */}
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Estados Especiais</h3>
          <div className="space-y-4">
            <Select
              options={[
                { value: 'success', label: '✅ Sucesso' },
                { value: 'warning', label: '⚠️ Atenção' },
                { value: 'error', label: '❌ Erro' },
              ]}
              placeholder="Estado da tarefa..."
              className="border-green-500 focus-visible:border-green-500 focus-visible:ring-green-500/20"
            />
          </div>
          <div className="mt-4 text-sm text-gray-600">
            <strong>Uso:</strong> Customização via className
          </div>
        </div>

      </div>

      {/* Seção de valores selecionados */}
      <div className="mt-8 bg-gray-50 p-6 rounded-lg">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Valores Selecionados</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
          <div>
            <strong>Simples:</strong> {simpleValue || 'Nenhum'}
          </div>
          <div>
            <strong>Categoria:</strong> {categoryValue || 'Nenhuma'}
          </div>
          <div>
            <strong>Usuário:</strong> {userValue || 'Nenhum'}
          </div>
          <div>
            <strong>Atribuído:</strong> {assigneeValue || 'Nenhum'}
          </div>
        </div>
      </div>

      {/* Seção de código */}
      <div className="mt-12 bg-white p-6 rounded-lg shadow-sm border">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Como usar</h3>
        <div className="bg-gray-50 p-4 rounded-md">
          <pre className="text-sm text-gray-800 overflow-x-auto">
{`import { Select } from '../../components/Select'

// Select Simples
<Select
  options={[
    { value: 'option1', label: 'Opção 1' },
    { value: 'option2', label: 'Opção 2' }
  ]}
  value={value}
  onChange={setValue}
  placeholder="Escolha uma opção..."
/>

// Select de Usuários com Busca
<Select
  variant="user"
  options={[
    {
      value: 'user1',
      label: 'João Silva',
      name: 'João Silva',
      email: 'joao@empresa.com',
      avatar: 'https://...'
    }
  ]}
  value={userValue}
  onChange={setUserValue}
  searchable
/>`}
          </pre>
        </div>
      </div>
    </ComponentsLayout>
  )
}